import { useEffect } from 'react';
import { EmailOTPValidationActions } from 'components/newAccountSteps/initialStep/sections/EmailOTPValidation/EmailOTPValidationReducer';

export const useEmailOTPValidationReset = ({ emailInputRef, dispatch, onboardingType }) => {
    useEffect(() => {
        dispatch({ type: EmailOTPValidationActions.RESET_EMAIL_OTP_VALIDATION });
        if (emailInputRef.current) emailInputRef.current.value = '';
    }, [onboardingType]);
};
